
      import "./src/index.ts";
      import LanguageServiceWorker from "@openworkflowspec/text-editor/worker?worker";
      import { sampleWorkflow } from "./src/sample-workflow.ts";

      const editor = document.querySelector("openworkflowspec-text-editor");
      editor.createLanguageServiceWorker = () => new LanguageServiceWorker();
      editor.content = sampleWorkflow;

      editor.addEventListener("change", (e) => {
        console.log("Workflow content changed:", e.detail.content);
      });
    